let _accessToken = null

export const setAccessToken = (token) => {
    _accessToken = token
}

export const getAccessToken = () => _accessToken

export const clearTokens = () => {
    _accessToken = null
}